import { createEvent, createStore, sample } from "effector";
import { ModelContract, ModuleDescription } from "@features/shared/module-description";
import { routePathNameChanged } from "@features/app/model";

export const LESSON_EXIT_FEEDBACK_METADATA_KEY = "lessonExitFeedbackShown";

const lessonExitConfirmRequested = createEvent();
const lessonExitCancelled = createEvent();
const lessonExitConfirmed = createEvent();
const lessonExitFeedbackOpened = createEvent();
const lessonExitFeedbackReasonChanged = createEvent<string>();
const lessonExitFeedbackCommentChanged = createEvent<string>();

const $isLessonExitModalOpen = createStore(false)
    .on(lessonExitConfirmRequested, () => true)
    .on(lessonExitCancelled, () => false)
    .on(lessonExitConfirmed, () => false);

const $lessonExitModalStep = createStore<"confirm" | "feedback">("confirm")
    .on(lessonExitConfirmRequested, () => "confirm")
    .on(lessonExitCancelled, () => "confirm")
    .on(lessonExitConfirmed, () => "confirm")
    .on(lessonExitFeedbackOpened, () => "feedback");

const $lessonExitFeedbackReason = createStore<string | null>(null)
    .on(lessonExitFeedbackReasonChanged, (_, value) => value)
    .reset(lessonExitConfirmRequested, lessonExitCancelled, lessonExitConfirmed);

const $lessonExitFeedbackComment = createStore<string>("")
    .on(lessonExitFeedbackCommentChanged, (_, value) => value)
    .reset(lessonExitConfirmRequested, lessonExitCancelled, lessonExitConfirmed);

const contract = new ModelContract(
    { $isLessonExitModalOpen, $lessonExitModalStep, $lessonExitFeedbackReason, $lessonExitFeedbackComment },
    {
        lessonExitConfirmRequested,
        lessonExitCancelled,
        lessonExitConfirmed,
        lessonExitFeedbackOpened,
        lessonExitFeedbackReasonChanged,
        lessonExitFeedbackCommentChanged
    },
    {},
    {}
);

export type ILessonExitConfirmationUiContract = typeof contract;

export class LessonExitConfirmationUiModule extends ModuleDescription<ILessonExitConfirmationUiContract> {
    getDefaultContract() {
        return contract;
    }

    run(): void {
        sample({
            clock: routePathNameChanged,
            target: lessonExitCancelled
        });
    }
}

